import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type Hash = `0x${string}`;

type UseAwaitingBlockchainPlacedBetsStoreState = {
  hashes: Hash[];
  addHash: (hash: Hash) => void;
  removeHash: (hash: Hash) => void;
};

export const useAwaitingBlockchainPlacedBetsStore =
  create<UseAwaitingBlockchainPlacedBetsStoreState>()(
    immer((set) => ({
      hashes: [],
      addHash: (hash) => {
        set((state) => {
          if (!state.hashes.includes(hash)) {
            state.hashes.push(hash);
          }
        });
      },
      removeHash: (hash) => {
        set((state) => {
          state.hashes = state.hashes.filter((h) => h !== hash);
        });
      },
    }))
  );
